import(/* webpackMode: "eager", webpackExports: ["HeaderRegionen"] */ "/app/src/app/_components/layouts/Header/HeaderRegionen/HeaderRegionen.tsx");
